import * as React from 'react';
import { CSVLink } from 'react-csv';

export type ICsvImportTemplateProps<FieldMapping> = {
  rows: { [key in keyof FieldMapping]?: string }[];
  filename: string;
  className?: string;
};

export function CsvImportTemplate<FieldMapping>(
  props: React.PropsWithChildren<ICsvImportTemplateProps<FieldMapping>>
): React.ReactElement | null {
  if (props.rows.length === 0) {
    return null;
  }

  const headers = Object.keys(props.rows[0]).map((key) => ({
    label: key,
    key: key,
  }));

  return (
    <CSVLink
      uFEFF={false}
      headers={headers}
      data={props.rows}
      filename={props.filename}
      className={props.className}
    >
      {props.children}
    </CSVLink>
  );
}
